import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { setLenis, scrollToId } from "@/lib/scroll";
import { ContentProvider, useContentLoaded } from "@/lib/content";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { BenefitsBanner } from "@/components/landing/BenefitsBanner";
import { Marquee } from "@/components/landing/Marquee";
import { WhyMove } from "@/components/landing/WhyMove";
import { VideoOS } from "@/components/landing/VideoOS";
import { UpgradeBanner } from "@/components/landing/UpgradeBanner";
import { WhatsBetter } from "@/components/landing/WhatsBetter";
import { LongTerm } from "@/components/landing/LongTerm";
import { Milestones } from "@/components/landing/Milestones";
import { Matrix } from "@/components/landing/Matrix";
import { Steps } from "@/components/landing/Steps";
import { Rooms } from "@/components/landing/Rooms";
import { LeadForm } from "@/components/landing/LeadForm";
import { Footer } from "@/components/landing/Footer";
import AdminPage from "@/pages/AdminPage";
import FitCheckPage from "@/pages/FitCheckPage";

function Landing() {
  const [selectedDevices, setSelectedDevices] = useState([]);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      const t = setTimeout(() => scrollToId(id), 700);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  const toggleDevice = (gen1) =>
    setSelectedDevices((prev) =>
      prev.includes(gen1) ? prev.filter((d) => d !== gen1) : [...prev, gen1]
    );

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    setLenis(lenis);
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App font-sans">
      <Nav />
      <main>
        <Hero />
        <WhyMove />
        <Marquee />
        <VideoOS />
        <BenefitsBanner />
        <WhatsBetter />
        <UpgradeBanner />
        <LongTerm />
        <Milestones />
        <Matrix selected={selectedDevices} onToggle={toggleDevice} />
        <Steps />
        <Rooms />
        <LeadForm selectedDevices={selectedDevices} />
      </main>
      <Footer />
    </div>
  );
}

function LandingGate() {
  const loaded = useContentLoaded();
  if (!loaded) {
    return (
      <div className="min-h-screen bg-white grid place-items-center">
        <span className="w-10 h-10 rounded-md bg-[#024AD8] grid place-items-center font-display font-extrabold text-white animate-pulse">hp</span>
      </div>
    );
  }
  return <Landing />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ContentProvider><LandingGate /></ContentProvider>} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/fit-check" element={<FitCheckPage />} />
      </Routes>
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
